import React from 'react';
import { useDrag } from 'react-dnd';

export function DragItem({ image, index, handleDragEnd, children }) {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: 'PHOTO',
    item: { id: image, index },
    end: (item, monitor) => {
      if (monitor.didDrop()) {
        handleDragEnd(item.id);
      }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }));

  return (
    <div ref={drag} style={{ opacity: isDragging ? 0.5 : 1 }}>
      {children}
    </div>
  );
};

export default DragItem;